import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Redirect } from 'react-router-dom';

import css from '../../../css/group/room/roomScreen.module.scss';
import { ReactComponent as Lock } from '../../../img/common/lock.svg';
import { ReactComponent as UnLock } from '../../../img/group/room/roomScreen/unlock.svg';
import { selectChatGroup } from '../../../slice/chatGroupSlice';
import { selectVoiceCall, updateRoom, lockRoom } from '../../../slice/voiceCallSlice';
import { ControlMyVoiceButton } from '../../common/controlMyVoiceButton';
import { ExitButton } from '../../common/exitButton';
import { MuteMyVoiceButton } from '../../common/muteMyVoiceButton';
import { Member } from './member';

export const RoomScreen: React.FC = () => {
    const { members, group, room } = useSelector(selectVoiceCall);
    const { groups, friendGroups } = useSelector(selectChatGroup);
    const dispatch = useDispatch();
    const joinedRoomId = room?.id;

    useEffect(() => {
        const foundRoom = [...groups, ...friendGroups]
            .flatMap((group) => group.chatRooms)
            .find((r) => r.id === joinedRoomId);
        if (foundRoom !== undefined) {
            dispatch(updateRoom(foundRoom));
        }
    }, [dispatch, groups, friendGroups, joinedRoomId]);

    const params = useParams<{
        groupId: string;
        roomId: string;
    }>();
    const groupId = Number(params.groupId);
    const roomId = Number(params.roomId);
    if (group?.id !== groupId || room?.id !== roomId) {
        if (isNaN(groupId)) {
            return <Redirect to={'/'} />;
        } else {
            return <Redirect to={`/groups/${groupId}`} />;
        }
    }

    return (
        <>
            <div className={css.content}>
                <ul>
                    {members.map((member, idx) => {
                        return (
                            <li key={idx}>
                                <Member member={member} />
                            </li>
                        );
                    })}
                </ul>
            </div>
            <div className={css.footer}>
                <ExitButton height={32} width={32} color={'#8E8E93'} />
                <MuteMyVoiceButton height={32} width={32} groupId={group.id} roomId={room.id} muteColor={'#D1D1D6'} />
                <ControlMyVoiceButton height={32} width={32} color={'#42A5F5'} />
                {room.isLock ? (
                    <Lock
                        height={32}
                        width={32}
                        fill={'#F6C359'}
                        role="img"
                        aria-label="アンロックする"
                        onClick={() => dispatch(lockRoom({ groupId: group.id, roomId: room.id, isLock: false }))}
                    />
                ) : (
                    <UnLock
                        height={32}
                        width={32}
                        fill={'#D1D1D6'}
                        role="img"
                        aria-label="ロックする"
                        onClick={() => dispatch(lockRoom({ groupId: group.id, roomId: room.id, isLock: true }))}
                    />
                )}
            </div>
        </>
    );
};
